module.exports = __webpack_public_path__ + "img/shoulder width.3ded6c6b.png";